'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import { useRegionLocale } from 'contexts/RegionLocaleContext';
import { useGlobalUI } from 'contexts/GlobalUIContext';
import { useIsIndiaRegion } from '../../hooks';
import styles from './PerformanceLabInternationalPricingCallout.module.css';

export const PerformanceLabInternationalPricingCallout: React.FC = () => {
  const t = useTranslations('performance-lab');
  const { detectedRegionFromGeoIP } = useRegionLocale();
  const isIndia = useIsIndiaRegion();
  const { headerHeight } = useGlobalUI();
  const topOffset = (headerHeight ?? 80) + 16;

  if (isIndia || detectedRegionFromGeoIP === 'IN') {
    return null;
  }

  return (
    <aside
      className={styles.calloutRoot}
      style={{ ['--pl-top-offset' as string]: `${topOffset}px` } as React.CSSProperties}
      role="status"
      aria-label={t('internationalPricingCallout.aria')}
    >
      <div className={styles.calloutBody}>
        <p className={styles.calloutText}>
          {t('internationalPricingCallout.line1')}
        </p>
        <p className={styles.calloutText}>
          {t('internationalPricingCallout.line2')}
        </p>
      </div>
    </aside>
  );
};
